import { Component, OnInit, ViewChild } from '@angular/core';
import {LeftSideService} from '../../_core/services/areas/left-side.service';
import {ProjectService} from '../../_core/services/project.service';
import {ProfileService} from '../../_core/services/profile.service';
import {RightSideService} from '../../_core/services/areas/right-side.service';
import {RoofService} from '../../_core/services/areas/roof.service';
import {FrontService} from '../../_core/services/areas/front.service';
import {ElementType} from '../../_core/models/ToolboxModel';
import {ColumnProfile} from '../../_core/models/profiles/column.model';
import {ChosenProfileService} from '../../_core/services/chosen-elements/chosen-profile.service';
import {Common} from '../../_core/models/common';
import { NumTbxComponent } from 'src/app/_shared/numeric-textbox/num-tbx.component';
import { COUNTRIES, SNOW_ZONES, SvgParams, WIND_ZONES, WIND_ZONES_TRANSLATIONS } from 'src/app/_core/constants/constants';
import { Glass } from 'src/app/_core/models/glasses/glass.model';
import { LayerLevel } from 'src/app/_core/interfaces/LayerLevel';
import { AreaType } from 'src/app/_core/interfaces/IAreaType';
import { GlassWallDiamondService } from 'src/app/_core/services/glass-walls/glass-wall-diamond.service';
import { GlassWallDiamond } from 'src/app/_core/models/glasses/glassWallDiamond.model';
import { RearService } from 'src/app/_core/services/areas/rear.service';
import { GlassWallService } from 'src/app/_core/services/glass-walls/glass-wall.service';
import { GlassWall } from 'src/app/_core/models/glasses/glassWall.model';
import { DoorCreator } from 'src/app/_core/models/doors/door-creator';
import { Door } from 'src/app/_core/models/doors/door.model';
import { AuthService } from 'src/app/_core/services/auth.service';
import { VerticalElement } from 'src/app/_core/models/vertical-element';
import { MarquiseVertical } from 'src/app/_core/models/marquises/marquise-vertical.model';
import { Wall } from 'src/app/_core/models/walls/wall.model';
import { ApiService } from 'src/app/_core/services/api.service';
import { ICalcInput } from 'src/app/_core/interfaces/ICalculations';
import { forkJoin } from 'rxjs';

@Component({
	selector: 'app-project-details',
	templateUrl: './project-details.component.html',
	styleUrls: ['./project-details.component.css']
})
export class ProjectDetailsComponent implements OnInit {
	@ViewChild('numElongLeft', { static: true }) numElongLeft: NumTbxComponent;
	@ViewChild('numElongRight', { static: true }) numElongRight: NumTbxComponent;
	@ViewChild('numBack', { static: true }) numBack: NumTbxComponent;
	@ViewChild('numFront', { static: true }) numFront: NumTbxComponent;
	@ViewChild('numWidth', { static: true }) numWidth: NumTbxComponent;
	@ViewChild('numDepth', { static: true }) numDepth: NumTbxComponent;
	@ViewChild('numDrop', { static: true }) numDrop: NumTbxComponent;
	@ViewChild('numBars', { static: true }) numBars: NumTbxComponent;
	@ViewChild('numCols', { static: true }) numCols: NumTbxComponent;

	justifyBarsToolTip: string = $localize`:Project details|Bars justify tooltip:Justify bars`;
	typesToCheck: ElementType[] = [ElementType.Led, ElementType.LedStripe, ElementType.MarquiseTopUp, ElementType.MarquiseTopBottom, ElementType.RoofWindow, ElementType.RoofGutter, ElementType.RoofVentilator];
	toExecute: string;

	frontDiff: number = 0;

	showLoading: boolean = true;
	messageLoading: string = "Please wait";

	isConfirmDialogOpened: boolean = false;
	confirmDialogMessage: string;

	positions: any[] = [];
	areasChanged: AreaType[] = [];

	lockStatus: boolean = false;

	//#region Setters / getters

	changeLock() {
		if (this.projectService.getLockStatusOfProjProp()) {
			this.openConfirmDialog();
		} else {
			this.projectService.lockProjProp();
		}
	}

	backHeightLocked: boolean = false;
	frontHeightLocked: boolean = false;
	dropAngleLocked: boolean = true;

	changePropertyLock(lock: string) {
		this.backHeightLocked = false;
		this.frontHeightLocked = false;
		this.dropAngleLocked = false;

		this[`${lock}Locked`] = true;
		localStorage.setItem("projectPropLocked", lock);
	}

	minFrontHeight: number = 0;
	maxFrontHeight: number = 0;

	minBackHeight: number = 0;
	maxBackHeight: number = 0;

	get frontId() {
		return this.projectService.template.frontId;
	}
	set frontId(id: string) {
		if (!this.frontHeightLocked) {
			this.projectService.template.frontHeight = 0;
		}
		this.roofService.applyTemplate(id, this.rearId, null, this.projectElongLeft, this.projectElongRight);
		this.profileService.removeVerticals(AreaType.Front);
		this.profileService.removeVerticals(AreaType.Roof);
		this.chosenProfileService.resetChosenProfileSubj.next();
		this.projectService.recalculateDimensions();
	}

	get rearId() {
		return this.projectService.template.rearId;
	}
	set rearId(id: string) {
		if (!this.frontHeightLocked) {
			this.projectService.template.frontHeight = 0;
		}
		this.roofService.applyTemplate(this.frontId, id, null, this.projectElongLeft, this.projectElongRight);
		this.profileService.removeVerticals(AreaType.Front);
		this.profileService.removeVerticals(AreaType.Roof);
		this.chosenProfileService.resetChosenProfileSubj.next();
		this.projectService.recalculateDimensions();
	}


	get barId() {
		return this.projectService.template.barId;
	}
	set barId(id: string) {
		if (!this.frontHeightLocked) {
			this.projectService.template.frontHeight = 0;
		}
		this.roofService.applyTemplate("", id, null, this.projectElongLeft, this.projectElongRight);
		this.chosenProfileService.resetChosenProfileSubj.next();
		this.projectService.recalculateDimensions();
	}

	get formSideId() {
		return this.projectService.template.formSideId;
	}
	set formSideId(id: string) {
		const fs = this.projectService.template.formSides.find(f => f.id == id);
		this.projectService.template.formSideId = id;
		this.projectService.template.setStandAlone(fs.isStandalone);
		if (!this.frontHeightLocked) {
			this.projectService.template.frontHeight = 0;
		}
		this.roofService.applyTemplate("", null, null, this.projectElongLeft, this.projectElongRight);
		this.profileService.removeVerticals();
		this.chosenProfileService.resetChosenProfileSubj.next();
		this.projectService.recalculateDimensions();
	}

	get fasteningId() {
		return this.projectService.template.fasteningId;
	}
	set fasteningId(id: string) {
		this.projectService.template.fasteningId = id;
		this.projectService.emitChange();
	}

	get projectBackHeight() {
		return this.projectService.template.backHeight;
	}

	set projectBackHeight(backHeight: number) {
		if (this.projectService.template.backHeight == backHeight) {
			return;
		}
		this.areasChanged = [];
		if (this.projectService.template.isFlat) {
			this.setFlatHeight(backHeight);
			return;
		}

		if (this.projectService.template.minDropAngle == this.projectService.template.maxDropAngle || this.dropAngleLocked) {
			const prevBackHeight = this.projectService.template.backHeight;
			const diff = backHeight - prevBackHeight;
			this.projectService.template.frontHeight += diff;
			this.projectService.template.backHeight = backHeight;
			this.projectService.template.columnLength += diff;
			this.profileService.removeVerticals(AreaType.Rear);
			this.profileService.removeVerticals(AreaType.Left);
			this.profileService.removeVerticals(AreaType.Right);
			this.profileService.removeVerticals(AreaType.Front);

			this.areasChanged.push(AreaType.Front);
			this.areasChanged.push(AreaType.Rear);

			this.repaint();
			this.updateFrontHeightBounds(backHeight, () => this.numBack.rebind(prevBackHeight));
			this.projectService.recalculateDimensions();
		} else {
			const newDropAngle = Common.calculateDrop(backHeight - this.projectService.template.frontHeight, this.projectService.template.depth);
			if (!this.canChangeHeight() || newDropAngle < this.projectService.template.minDropAngle || newDropAngle > this.projectService.template.maxDropAngle) {
				this.numBack.rebind(this.projectService.template.backHeight);
				return;
			}
			const prevBackHeight = this.projectService.template.backHeight;
			this.updateFrontHeightBounds(backHeight, () => this.numBack.rebind(prevBackHeight), () => {
				this.positions = [];
				var verts = this.profileService.getVerticals(AreaType.Front);
				verts.forEach((v: VerticalElement) => {
					this.positions.push({ id: v.id, distance: Math.round(v.locationY) - Math.round(v.minLocationY)});
				});
				this.projectService.template.backHeight = backHeight;
				this.projectService.template.dropAngle = 0;

				this.profileService.removeVerticals(AreaType.Roof);
				this.profileService.removeVerticals(AreaType.Left);
				this.profileService.removeVerticals(AreaType.Right);
				this.profileService.removeVerticals(AreaType.Rear);

				this.areasChanged.push(AreaType.Front);
				this.areasChanged.push(AreaType.Rear);

				this.roofService.calculateTemplate(
					backHeight,
					this.frontHeightLocked ? Math.round(this.projectService.template.frontHeight) : 0,
					this.projectService.template.dropAngle);
			});
		}
	}

	get newProjectFrontHeight() {
		if (!this.profileService?.roofElements) {
			return 0;
		}
		if (this.projectService.template.isFlat) {
			return this.projectService.template.frontHeight;
		}
		return Math.round(this.projectService.template.columnLength);
	}

	set newProjectFrontHeight(v: number) {
		if (!this.profileService?.roofElements) {
			return;
		}
		this.projectFrontHeight = v; // - this.profileService.reinforcementDiff;
	}

	get projectFrontHeight() {
		return Math.round(this.projectService.template.columnLength);
	}

	set projectFrontHeight(frontHeight: number) {
		if (Math.round(this.projectService.template.frontHeight) == frontHeight) {
			return;
		}
		this.areasChanged = [];
		
		if (this.projectService.template.isFlat) {
			this.setFlatHeight(frontHeight);
			this.projectService.emitChange();
			return;
		}

		if (this.projectService.template.minDropAngle == this.projectService.template.maxDropAngle || this.dropAngleLocked) {
			const prevFrontHeight = this.newProjectFrontHeight;
			const diff = frontHeight - prevFrontHeight;
			this.projectService.template.backHeight += diff;
			this.projectService.template.frontHeight = frontHeight;
			this.projectService.template.columnLength += diff;
			this.profileService.removeVerticals(AreaType.Rear);
			this.profileService.removeVerticals(AreaType.Left);
			this.profileService.removeVerticals(AreaType.Right);
			this.profileService.removeVerticals(AreaType.Front);

			this.areasChanged.push(AreaType.Front);
			this.areasChanged.push(AreaType.Rear);

			this.repaint();
			this.updateBackHeightBounds(frontHeight, () => this.numFront.rebind(prevFrontHeight));
			this.projectService.recalculateDimensions();
		} else {
			const newDropAngle = Common.calculateDrop(this.projectService.template.backHeight - frontHeight, this.projectService.template.depth);
			if (!this.canChangeHeight() || newDropAngle < this.projectService.template.minDropAngle || newDropAngle > this.projectService.template.maxDropAngle) {
				this.numFront.rebind(this.projectService.template.frontHeight);
				return;
			}
			const fh = this.backHeightLocked ? frontHeight + this.profileService.reinforcementDiff : frontHeight;
			const prevFrontHeight = this.newProjectFrontHeight;
			this.updateBackHeightBounds(fh, () => this.numFront.rebind(prevFrontHeight), () => {
				this.projectService.template.frontHeight = fh;
				this.projectService.template.dropAngle = 0;

				this.profileService.removeVerticals(AreaType.Roof);
				this.profileService.removeVerticals(AreaType.Left);
				this.profileService.removeVerticals(AreaType.Right);
				this.profileService.removeVerticals(AreaType.Front);

				this.areasChanged.push(AreaType.Front);
				this.areasChanged.push(AreaType.Rear);

				this.roofService.calculateTemplate(
					this.backHeightLocked ? Math.round(this.projectService.template.backHeight) : 0,
					fh,
					this.projectService.template.dropAngle);
			});
		}

	}

	get projectWidth() {
		return this.projectService.template.width;
	}
	set projectWidth(width: number) {
		this.profileService.removeVerticals(AreaType.Front);
		this.profileService.removeVerticals(AreaType.Roof);
		this.projectService.template.width = width;
		this.projectService.template.frontHeight = null;
		this.refresh();
	}

	get projectDepth() {
		return this.projectService.template.depth;
	}
	set projectDepth(newDepth: number) {
		const newDropAngle = Common.calculateDrop(this.projectService.template.backHeight - this.projectService.template.frontHeight, newDepth);
		if (newDropAngle < this.projectService.template.minDropAngle || newDropAngle > this.projectService.template.maxDropAngle) {
			this.numDepth.rebind(this.projectService.template.depth);
			return;
		}

		this.projectService.template.depth = newDepth;
		if (this.isAnyLockedColumn()) {
			this.projectService.template.dropAngle = newDropAngle;
		}
		this.profileService.removeVerticals();
		this.refresh();
	}

	get projectElongLeft() {
		return this.projectService.template.elongLeft;
	}

	set projectElongLeft(value: number) {
		if (!this.frontHeightLocked) {
			this.projectService.template.frontHeight = 0;
		}
		this.roofService.applyTemplate("", "", null, value, this.projectService.template.elongRight);
	}

	get projectElongRight() {
		return this.projectService.template.elongRight;
	}

	set projectElongRight(value: number) {
		if (!this.frontHeightLocked) {
			this.projectService.template.frontHeight = 0;
		}
		this.roofService.applyTemplate("", "", null, this.projectService.template.elongLeft, value);
	}

	private _projectBarsCount: number;
	get projectBarsCount() {
		this._projectBarsCount = this.profileService.roofElements == null ? 0 : this.profileService.roofElements[ElementType.Bar].length + 2;
		return Math.max(this._projectBarsCount, this.projectService.template.staticBarsCount);
	}
	set projectBarsCount(newCount: number) {
		var re = this.typesToCheck.reduce((acc, obj) => {
			return acc + this.profileService.roofElements[obj].length;
		}, 0);

		if (re == 0) {
			re = this.profileService.roofElements[ElementType.Glass].find((g: Glass) => g.configId != this.projectService.template.glassId ) ? 1 : 0;
		}
		if (re > 0) {
			this.toExecute = `this.setBarsCount(${newCount});`;
			this.isConfirmDialogOpened = true;
			this.confirmDialogMessage = $localize`:Messages|Bars confirmation:Are you sure? This operation will remove customization and additions on the roof!`;
			return;
		} else {
			this.setBarsCount(newCount);
		}

	}

	get projectColsCount() {
		return this.profileService.roofElements == null ? 0 : this.profileService.roofElements[ElementType.Column].length;
	}

	private setBarsCount(newCount: number) {
		this.roofService.setBars(newCount);
		this.projectService.clearCollections(ElementType.ProfileConnector);
		this.projectService.addBarsConnectors();

		this.projectService.ledPattern = undefined;
		this.typesToCheck.forEach(t => { this.projectService.clearCollections(t) });
		this.profileService.removeVerticals(AreaType.Front);
		this.profileService.removeVerticals(AreaType.Roof);

		this.chosenProfileService.resetChosenProfileSubj.next();
		this.projectService.recalculateDimensions();
		this.projectService.emitChange();
	}

	get projectDropAngle() {
		return this.projectService.template.dropAngle;
	}
	set projectDropAngle(newDropAngle: number) {
		this.projectService.template.dropAngle = newDropAngle;
		if (this.backHeightLocked) {
			this.projectService.template.frontHeight = 0;
		} else if (this.frontHeightLocked) {
			this.projectService.template.backHeight = 0;
		}
		this.profileService.removeVerticals();
		this.refresh();
		this.roofService.calculateTemplate(
			Math.round(this.projectService.template.backHeight),
			Math.round(this.projectService.template.frontHeight),
			newDropAngle);
	}

	get snowZones() {
		return SNOW_ZONES[this.projectService.template.country];
	}

	get windZones() {
		var windZoneValues = [];
		if (!WIND_ZONES[this.projectService.template.country]) {
			return windZoneValues;
		}
		WIND_ZONES[this.projectService.template.country].forEach(wz => {
			windZoneValues.push({ zone: wz, label: WIND_ZONES_TRANSLATIONS.get(wz) ?? wz });
		});
		return windZoneValues;
	}

	get countries() {
		return COUNTRIES;
	}

	get validationIcon() {
		return this.projectService.errors?.length > 0 ? this.projectService.svgIcons.xCircleIcon : this.projectService.svgIcons.checkCircleIcon;
	}

	//#endregion

	private updateBackHeightBounds(frontHeight: number, onFail?: () => void, onSuccess?: () => void) {
		const template = this.projectService.template;
		const baseInput: ICalcInput = {
			frontId: template.frontId,
			rearId: template.rearId,
			glassId: template.glassId,
			windZone: template.windZone,
			snowZone: template.snowZone,
			country: template.country,
			width: template.width,
			depth: template.depth,
			backHeight: 0,
			isStandalone: template.isStandalone,
			frontHeight: Math.round(template.frontHeight),
			dropAngle: 0,
			elongLeft: template.elongLeft,
			elongRight: template.elongRight,
			useStatics: this.projectService.useStatics
		};

		forkJoin([
			this.apiService.calculateConstruction(template.productId, template.brandName, { ...baseInput, dropAngle: template.minDropAngle }),
			this.apiService.calculateConstruction(template.productId, template.brandName, { ...baseInput, dropAngle: template.maxDropAngle })
		]).subscribe(([minResult, maxResult]) => {
			const minOk = minResult.ok && minResult.segments?.length > 0;
			const maxOk = maxResult.ok && maxResult.segments?.length > 0;
			if (!minOk || !maxOk) {
				onFail?.();
				return;
			}
			this.minBackHeight = Math.round(minResult.segments[0].backHeight);
			this.maxBackHeight = Math.round(maxResult.segments[0].backHeight);
			onSuccess?.();
		});
	}

	private updateFrontHeightBounds(backHeight: number, onFail?: () => void, onSuccess?: () => void) {
		const template = this.projectService.template;
		const baseInput: ICalcInput = {
			frontId: template.frontId,
			rearId: template.rearId,
			glassId: template.glassId,
			windZone: template.windZone,
			snowZone: template.snowZone,
			country: template.country,
			width: template.width,
			depth: template.depth,
			backHeight: Math.round(template.backHeight),
			isStandalone: template.isStandalone,
			frontHeight: 0,
			dropAngle: 0,
			elongLeft: template.elongLeft,
			elongRight: template.elongRight,
			useStatics: this.projectService.useStatics
		};

		forkJoin([
			this.apiService.calculateConstruction(template.productId, template.brandName, { ...baseInput, dropAngle: template.minDropAngle }),
			this.apiService.calculateConstruction(template.productId, template.brandName, { ...baseInput, dropAngle: template.maxDropAngle })
		]).subscribe(([minResult, maxResult]) => {
			const minOk = minResult.ok && minResult.segments?.length > 0;
			const maxOk = maxResult.ok && maxResult.segments?.length > 0;
			if (!minOk || !maxOk) {
				onFail?.();
				return;
			}
			this.maxFrontHeight = Math.round(minResult.segments[0].columnLength);
			this.minFrontHeight = Math.round(maxResult.segments[0].columnLength);
			onSuccess?.();
		});
	}

	constructor(
		public projectService: ProjectService,
		public roofService: RoofService,
		public frontService: FrontService,
		public leftSideService: LeftSideService,
		public rightSideService: RightSideService,
		public profileService: ProfileService,
		public chosenProfileService: ChosenProfileService,
		private rearService: RearService,
		private leftService: LeftSideService,
		private rightService: RightSideService,
		private authService: AuthService,
		private apiService: ApiService
	) {
		this.roofService.projectReady.subscribe((s: boolean) => {
			if (!s) {
				return;
			}
			this.repaint();
			this.updateFrontHeightBounds(this.projectService.template.backHeight);
			this.updateBackHeightBounds(this.projectService.template.columnLength);
		});
		this.roofService.projectRefreshed.subscribe((s: boolean) => {
			if (!s) {
				return;
			}
			this.updateFrontHeightBounds(this.projectService.template.backHeight);
			this.updateBackHeightBounds(this.projectService.template.columnLength);
		});
		if (localStorage.getItem("projectPropLocked")) {
			this.backHeightLocked = false;
			this.frontHeightLocked = false;
			this.dropAngleLocked = false;
			this[`${localStorage.getItem("projectPropLocked")}Locked`] = true;
		}
	}

	private repaint() {
		this.refresh(false);
		this.areasChanged.forEach(area => {
			this.profileService.repaintColumns(this.projectService.template, area);
		});
		if (this.positions.length > 0) {
			this.adjustFrontElements(this.positions);
		}
		this.areasChanged = [];
		this.positions = [];
		this.projectService.recalculateDimensions();
		this.projectService.emitChange();
	}

	ngOnInit(): void {

		this.projectService.elementsChanged.subscribe(flag => {
			if (!flag) {
				return;
			}
			this.frontDiff = this.projectService.template.isFlat ? 0 : this.projectService.template.backHeight - this.projectService.template.columnLength;

			this.projectService.recalculateDimensions();
			this.numBack.rebind(this.projectBackHeight, false);
			this.numFront.rebind(this.newProjectFrontHeight, false);
			this.numWidth.rebind(this.projectWidth, false);
			this.numDrop.rebind(this.projectDropAngle, false);
			this.numBars.rebind(this.projectService.template.staticBarsCount, false);
		});

		this.projectService.projectReady.subscribe(item => {
			if (!item) {
				return;
			}
			this._projectBarsCount = this.projectService.template.barsCount + 2;
			this.frontDiff = this.projectService.template.isFlat ? 0 : this.projectService.template.backHeight - this.projectService.template.columnLength;
			this.updateFrontHeightBounds(this.projectService.template.backHeight);
			this.updateBackHeightBounds(this.projectService.template.columnLength);
			setTimeout(() => {
				this.showLoading = false;
			}, 1000);
		}, error => {
			this.showLoading = false
		});

		this.projectService.projLockChanged.subscribe(locked => {
			this.lockStatus = locked;
		});

		this.numFront.valueChanged.subscribe(v => {
			this.newProjectFrontHeight = v;
		});

		this.numBack.valueChanged.subscribe(v => {
			this.projectBackHeight = v;
		});

		this.numWidth.valueChanged.subscribe(v => {
			this.projectWidth = v;
		});

		this.numDepth.valueChanged.subscribe(v => {
			this.projectDepth = v;
		});

		this.numDrop.valueChanged.subscribe(v => {
			this.projectDropAngle = v;
		});

		this.numBars.valueChanged.subscribe(v => {
			this.projectBarsCount = v;
		});

		// if (this.numElongLeft && this.numElongRight) {
		// 	this.numElongLeft.valueChanged.subscribe(v => {
		// 		this.projectElongLeft = v;
		// 	});
		// 	this.numElongRight.valueChanged.subscribe(v => {
		// 		this.projectElongRight = v;
		// 	});
		// }
	}

	private setFlatHeight(value: number) {
		this.projectService.template.backHeight = value;
		this.projectService.template.frontHeight = value;
		this.projectService.template.columnLength = value;
		this.frontDiff = 0;
		this.profileService.removeVerticals(AreaType.Rear);
		this.profileService.removeVerticals(AreaType.Left);
		this.profileService.removeVerticals(AreaType.Right);
		this.profileService.removeVerticals(AreaType.Front);
		this.areasChanged.push(AreaType.Front);
		this.areasChanged.push(AreaType.Rear);
		this.repaint();
		this.projectService.emitChange();
	}

	onAfterValueChange(): void {
		this.projectService.recalculateDimensions();
	}

	isAnyLockedColumn() {
		return this.profileService.roofElements[ElementType.Column].find((col: ColumnProfile) => col.locked === true)
	}

	recalculate() {
		if (!this.frontHeightLocked) {
			this.projectService.template.frontHeight = 0;
		}
		this.roofService.applyTemplate("", "");
	}

	setStandalone(standalone: boolean) {
		if (standalone == this.projectService.template.isStandalone) {
			return;
		}
		this.projectService.template.setStandAlone(standalone);
		if (!this.frontHeightLocked) {
			this.projectService.template.frontHeight = 0;
		}
		this.roofService.applyTemplate("", null, null, this.projectElongLeft, this.projectElongRight);
	}

	openConfirmDialog() {
		this.toExecute = "this.projectService.unlockProjProp();";
		this.isConfirmDialogOpened = true;
		this.confirmDialogMessage = $localize`:Messages|Unlock confirmation:Are you sure? The project will be rebuilt and all additions will be lost!`;
	}

	onConfirmDialogAction(status: any) {
		if (status.status) {
			eval(this.toExecute);
			this.toExecute = "";
		} else {
			this.lockStatus = true;
		}
		this.isConfirmDialogOpened = false;

	}

	refresh(reset: boolean = true) {
		if (reset) {
			this.roofService.changeArea();
		}
		this.chosenProfileService.resetChosenProfileSubj.next();
		this.roofService.calculatePoints();
		this.frontService.calculatePoints();
		this.rearService.calculatePoints();
		this.leftService.calculatePoints();
		this.rightService.calculatePoints();
		this.projectService.CurrentAreaService.showArea();
	}

	get currLng(): string {
		return window.document.documentElement.lang;
	}

	justifyBars() {
		this.projectBarsCount = this.numBars.value;
	}

	justifyColumns() {
		this.projectService.clearCollections(ElementType.Dimension);
		this.profileService.justifyColumns(this.projectService.template.width, true);
		this.profileService.justifyColumns(this.projectService.template.width, false);
		this.projectService.emitChange();
	}

	canChangeHeight() {
		return true;
		// return this.projectService.profileService.getVerticals(AreaType.Left).length == 0 &&
		// 	this.projectService.profileService.getVerticals(AreaType.Right).length == 0;
	}
	adjustElements(oldBottom: number, diff: number){
		var verts = this.profileService.findVerticalsOnBottom(oldBottom);

		verts.forEach(v => {
			var newHeight = v.height + diff;
			if (newHeight > v.defMaxHeight) {
				newHeight = v.defMaxHeight;
			}
			if (newHeight > v.maxHeight) {
				newHeight = v.maxHeight;
			}
			switch(v.type) {
				case ElementType.GlassWallDiamond:
					new GlassWallDiamondService(this.projectService).alongHeight(v as GlassWallDiamond, diff);
					break;					
				case ElementType.GlassWall:
					new GlassWallService(this.projectService).alongHeight(v as GlassWall, diff);
					break;					
				case ElementType.Door:
					var d = v as Door;
					var creator = DoorCreator.fromInstance(this.projectService, d, this.projectService.CurrentAreaService);
					creator.setHeight(d, newHeight, false);
					break;					
				default:
					v.height = newHeight;
					break;
			}
			v.refreshSurround(this.profileService);
		});
		
	}

	adjustFrontElements(positions: { id: string, distance: number }[]){
		var verts = this.profileService.getVerticals(AreaType.Front);

		verts.forEach((v: VerticalElement) => {
			var pos = positions.find(p => p.id == v.id);
			var newTop = v.minLocationY + pos.distance;
			switch(v.type) {
				case ElementType.MarquiseVertical:
					(v as MarquiseVertical).alignVert(pos.distance);
					break;
				case ElementType.Wall:
					(v as Wall).locationY = newTop;
					break;
				case ElementType.GlassWall:
					var g = v as GlassWall;
					new GlassWallService(this.projectService).setLocationY(g, newTop, true);
					break;
				case ElementType.Door:
					var d = v as Door;
					var creator = DoorCreator.fromInstance(this.projectService, d, this.projectService.CurrentAreaService);
					creator.setLocationY(d, newTop, false);
					break;					
				default:
					break;
			};
			// v.refreshSurround(this.profileService);		

		});
		
	}

	colsSelectedChange(s: boolean) {
		if (s) {
			this.justifyColumns();
			this.profileService.columnsJustified = true;
		}
	}

	barsSelectedChange(s: boolean) {
		if (s) {
			this.justifyBars();
			this.profileService.barsJustified = true;
		}
	}
}
